/**
 * Harita katmanı (Leaflet). Tek yerde tutulur: yük artarsa MapTiler / Google gibi bir
 * sağlayıcıya geçmek için yalnız buradaki adres ve atıf değişir.
 */
export const MAP_TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

export const MAP_TILE_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export const MAP_MAX_ZOOM = 19;

/** Google Maps'te bir noktayı açan bağlantı. */
export const googleMapsPointUrl = (lat: number, lng: number): string =>
  `https://www.google.com/maps?q=${lat.toFixed(6)},${lng.toFixed(6)}`;
